import PropTypes from 'prop-types'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { IconMapPin } from '@calendly/ui/components/glyphs/IconMapPin'
import { IconPhone } from '@calendly/ui/components/glyphs/IconPhone'

import GoogleMeetLogo from 'images/logos/google-meet.svg'
import ZoomLogo from 'images/logos/zoom.svg'
import MsTeamsLogo from 'images/logos/ms-teams.svg'
import WebexLogo from 'images/logos/webex.svg'
import GotomeetingLogo from 'images/logos/gotomeeting.svg'

const CONFERENCE_LOGOS = {
  google_conference: GoogleMeetLogo,
  zoom_conference: ZoomLogo,
  microsoft_teams_conference: MsTeamsLogo,
  webex_conference: WebexLogo,
  gotomeeting_conference: GotomeetingLogo
}

const GLYPHS_FOR_KIND = {
  physical: IconMapPin,
  custom: IconMapPin,
  ask_invitee: IconMapPin,
  inbound_call: IconPhone,
  outbound_call: IconPhone
}

// Logos are SVG assets rendered as <img>. Without an explicit size, Safari falls back to the
// default object size (300x150 clamped by the aspect ratio) instead of shrinking to the
// 24px icon column, so the size is set here and not left to the asset or container.
const LOGO_SIZE = 24

const Logo = ({ Icon, ...props }) => (
  typeof Icon === 'string'
    ? <img src={Icon} alt="" width={LOGO_SIZE} height={LOGO_SIZE} {...props} />
    : <Icon {...props} />
)

export const LocationIcon = ({ kind, size = 'small', ...props }) => {
  const ConferenceLogo = CONFERENCE_LOGOS[kind]
  if (ConferenceLogo) {
    return <Logo Icon={ConferenceLogo} {...props} />
  }

  return (
    <UiIcon
      icon={GLYPHS_FOR_KIND[kind] || IconMapPin}
      size={size}
      {...props}
    />
  )
}

LocationIcon.propTypes = {
  kind: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium'])
}
